/**
 * @generated SignedSource<<c10001191ca1c76edc5906e30be98b2f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppVersion_version$data = {
  readonly cloudCustodianVersion: string;
  readonly version: string;
  readonly " $fragmentType": "AppVersion_version";
};
export type AppVersion_version$key = {
  readonly " $data"?: AppVersion_version$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppVersion_version">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppVersion_version",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cloudCustodianVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

(node as any).hash = "d823fc5ee863350c523c8986767b8bd1";

export default node;
